import { Button, StandardDialog } from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { PersonalIdentificationForm } from './personalIdentificatonForm';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

type Props = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const PersonalIdentificationDialog = observer((props: Props) => {
  const { open, onClose, loan, document } = props;
  const taskId = document?.taskId;
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { personalIdentificationFormStore } = documentFormStore;

  useEffect(() => {
    if (open) {
      const { loanId, borrowerId } = document;
      personalIdentificationFormStore.reset();
      personalIdentificationFormStore.getIdentificationTypeData(
        loanId,
        borrowerId
      );
    }
  }, [open]);

  const getActions = () => {
    return (
      <>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          testId="close"
        >
          Close
        </Button>
      </>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Personal Identification"
          handleClose={onClose}
          dialogContent={<PersonalIdentificationForm document={document} />}
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Personal Identification"
          maxWidth="sm"
          handleClose={onClose}
          dialogContent={<PersonalIdentificationForm document={document} />}
          dialogActions={getActions()}
        />
      )}
    </>
  );
});
